﻿import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { FunctionComponent, PropsWithChildren, useEffect, useState } from "react";
import { useEnvironmentContext } from "../EnvironmentContext";
import { PageLoading } from "../../components";

export type AuthenticationContextProviderProps = PropsWithChildren;

export const AuthenticationContextProvider: FunctionComponent<PropsWithChildren> = ({ children }) => {
    const envConfig = useEnvironmentContext();
    const [msalInstance, setMsalInstance] = useState<PublicClientApplication>();

    useEffect(() => {
        if (envConfig.auth) {
            const msalInstance = new PublicClientApplication({
                auth: envConfig.auth,
                cache: {
                    cacheLocation: "localStorage", // localStorage persists across tabs; sessionStorage would require re-auth in each new tab
                    storeAuthStateInCookie: true, // Set this to "true" if you are having issues on IE11 or Edge
                },
            });

            msalInstance.initialize().then(() => {
                setMsalInstance(msalInstance);
            });
        }
    }, [envConfig.auth]);

    return msalInstance ? <MsalProvider instance={msalInstance}>{children}</MsalProvider> : <PageLoading text={"Initializing Authentication Provider..."} />;
};
